"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fulfillWithTimeLimit = exports.isEmptyObject = exports.extractUTMAdIds = exports.expiryParamBuilder = exports.getCookieExpiryFromUTM = exports.getEditorUrl = exports.isEditorMode = exports.getExtensionLink = exports.getUrlParams = exports.isStaging = exports.redirectToPremiumPageForPromoCodeExtentionUsers = exports.checkForPromoCode = exports.updateCookie = exports.UpdateWordtuneCookieWithUrlParams = exports.getCookie = exports.iterateSearchParams = void 0;
const react_device_detect_1 = require("react-device-detect");
const constants_1 = require("../constants");
function getCurrentDate() {
    return new Date().toISOString().split(".")[0];
}
function overrideExistingDataInTheCookie(cookieObj, searchParams, param) {
    if (param == "p") {
        cookieObj["WordtunePromoCode"] = searchParams.get(param);
        window.sessionStorage.setItem("p", searchParams.get(param) || "");
    }
    cookieObj[param] = searchParams.get(param);
}
function iterateSearchParams(array, searchParams, cookieObj) {
    array.forEach((param) => {
        // don't clean if not unset
        if (searchParams.has(param)) {
            overrideExistingDataInTheCookie(cookieObj, searchParams, param);
        }
    });
}
exports.iterateSearchParams = iterateSearchParams;
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(window.document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
exports.getCookie = getCookie;
function UpdateWordtuneCookieWithUrlParams() {
    let existingCookieString = getCookie(constants_1.INSTALL_INFO_COOKIE);
    const isCookieExist = existingCookieString.length !== 0;
    let cookieObj;
    const currentDate = getCurrentDate();
    if (!isCookieExist) {
        cookieObj = { cookieCreationTime: currentDate };
    }
    else {
        if (document.referrer.includes(constants_1.WORDTUNE_BASE_URL_PROD)) {
            return;
        }
        cookieObj = JSON.parse(existingCookieString);
    }
    const searchParams = new URLSearchParams(window.location.search);
    const utmSource = searchParams.get(constants_1.SITE_SOURCE) === "null"
        ? null
        : searchParams.get(constants_1.SITE_SOURCE);
    const campaignName = searchParams.get(constants_1.CAMPAIGN_SOURCE) || "";
    const isNewOrganic = !utmSource;
    const isEngineSearch = utmSource === constants_1.GOOGLE_SEARCH || utmSource === constants_1.BING_SEARCH;
    const isBrandAd = detectBrandedAd(campaignName);
    const isNewBrandSearch = isEngineSearch && isBrandAd;
    const currentUtmSource = cookieObj[constants_1.SITE_SOURCE] || "";
    const currentCampaignName = cookieObj[constants_1.CAMPAIGN_SOURCE] || "";
    const currentOrganic = !currentUtmSource;
    const currentEngineSearch = currentUtmSource === constants_1.GOOGLE_SEARCH || currentUtmSource === constants_1.BING_SEARCH;
    const currentBrandAd = detectBrandedAd(currentCampaignName);
    const currentBrandSearch = currentEngineSearch && currentBrandAd;
    /// Cookie Attribution Logic ///
    /// Attribution Logic flow chart - https://www.figma.com/file/j3k9sQCjFhoQ8dboId9NQ6/Cookie-creation-and-update-(Oct.-2023)?type=whiteboard&node-id=0%3A1&t=VBDf49ymAZB1RWT1-1
    if (!isCookieExist) {
        storeParamsAndUpdateCookie();
        return;
    }
    if (!(constants_1.SITE_SOURCE in cookieObj)) {
        storeParamsAndUpdateCookie();
        return;
    }
    if (isNewOrganic) {
        return;
    }
    if (!isNewBrandSearch) {
        storeParamsAndUpdateCookie();
        return;
    }
    if (currentBrandSearch || currentOrganic) {
        storeParamsAndUpdateCookie();
        return;
    }
    return;
    /// END Cookie Attribution Logic ///
    function storeParamsAndUpdateCookie() {
        constants_1.URL_PARAMS_TO_EXTRACT.forEach((param) => {
            overrideExistingDataInTheCookie(cookieObj, searchParams, param);
        });
        iterateSearchParams(constants_1.URL_PARAMS_TO_EXTRACT, searchParams, cookieObj);
        iterateSearchParams(constants_1.CLICK_IDENTIFIERS, searchParams, cookieObj);
        // add fbc and fbp data
        const fbc = getCookie(constants_1.FACEBOOK_CLICK_DATA);
        if (fbc) {
            cookieObj[constants_1.FACEBOOK_CLICK_DATA_FIELD_NAME] = fbc;
        }
        const fbp = getCookie(constants_1.FACEBOOK_PIXEL_IDENTIFIER);
        if (fbp) {
            cookieObj[constants_1.FACEBOOK_PIXEL_IDENTIFIER_FIELD_NAME] = fbp;
        }
        // get referrer from url param since this is a redirect
        cookieObj.rPath = "";
        if (searchParams.has("r")) {
            cookieObj.rPath = searchParams.get("r");
        }
        // get hash email from url param since this is a redirect
        if (searchParams.has("he")) {
            cookieObj.he = searchParams.get("he");
        }
        cookieObj.rPath = document.referrer;
        const match = cookieObj.rPath.match(/(?:(?:https?|ftp|file):\/\/)[^\/]+/);
        cookieObj.r = match ? match[0] : cookieObj.rPath;
        cookieObj.cookieLastUpdateTime = currentDate;
        updateCookie(cookieObj, true);
    }
}
exports.UpdateWordtuneCookieWithUrlParams = UpdateWordtuneCookieWithUrlParams;
function updateCookie(props, updateExpiration = false) {
    try {
        let existingCookieString = getCookie(constants_1.INSTALL_INFO_COOKIE) || "{}";
        let cookieObj = JSON.parse(existingCookieString);
        cookieObj = { ...cookieObj, ...props };
        cookieObj.cookieLastUpdateTime = getCurrentDate();
        const currentUtmSource = cookieObj[constants_1.SITE_SOURCE] === "null" ? null : cookieObj[constants_1.SITE_SOURCE];
        const expairyTime = getCookieExpiryFromUTM(currentUtmSource);
        const expiryString = expiryParamBuilder(expairyTime);
        // update/keep cookie Expiration Date
        cookieObj.ExpirationDate = updateExpiration
            ? expiryString
            : cookieObj.ExpirationDate;
        // End //
        let params = `; expires=${cookieObj.ExpirationDate};SameSite=None; Secure; path=/; Domain=${!(0, exports.isStaging)() ? "wordtune.com" : "wordtune-stg.com"}`;
        window.document.cookie = `${constants_1.INSTALL_INFO_COOKIE}=${JSON.stringify(cookieObj) + params}`;
    }
    catch (e) {
        console.log("Can't update cookie, ", e);
    }
}
exports.updateCookie = updateCookie;
const checkForPromoCode = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("p");
    const isStaging = !window.location.href.includes("wordtune.com");
    const isPlansPage = window.location.href.includes("plans");
    const productUrl = isStaging
        ? "https://app.wordtune-stg.com"
        : "https://app.wordtune.com";
    if (myParam && myParam.length && isPlansPage) {
        window.location.href = `${productUrl}/premium?p=${myParam}`;
    }
};
exports.checkForPromoCode = checkForPromoCode;
// Chrome 1 - 79
const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
// Edge 20+
const isEdge = !!window.StyleMedia;
// Edge (based on chromium) detection
const isEdgeChromium = isChrome && navigator.userAgent.indexOf("Edg") != -1;
function getExtentionIdForChrome(staging) {
    return staging ? constants_1.STAGING_EXTENTION_ID_CHROME : constants_1.PRODUCTION_EXTENTION_ID_CHROME;
}
function getExtentionIdForEdge(staging) {
    return staging ? constants_1.STAGING_EXTENTION_ID_EDGE : constants_1.PRODUCTION_EXTENTION_ID_EDGE;
}
function redirectToPremiumPageForPromoCodeExtentionUsers() {
    const urlParams = new URLSearchParams(window.location.search);
    const promoCode = urlParams.get(constants_1.PROMO_CODE);
    if (promoCode) {
        const staging = (0, exports.isStaging)();
        let extensionId = getExtentionIdForChrome(staging);
        if (isEdge || isEdgeChromium) {
            extensionId = getExtentionIdForEdge(staging);
        }
        window.chrome.runtime.sendMessage(extensionId, { message: "userInfo" }, function (reply) {
            if (reply) {
                let url = `${constants_1.WORDTUNE_BASE_URL_PROD}/premium`;
                if (staging) {
                    url = `${constants_1.WORDTUNE_BASE_URL_STG}/premium`;
                }
                url = url + window.location.search;
                window.location.replace(url);
            }
        });
    }
}
exports.redirectToPremiumPageForPromoCodeExtentionUsers = redirectToPremiumPageForPromoCodeExtentionUsers;
const isStaging = () => {
    return !window.location.hostname.includes("wordtune.com");
};
exports.isStaging = isStaging;
function getUrlParams() {
    //@ts-ignore
    return Object.fromEntries(new URLSearchParams(window.location.search));
}
exports.getUrlParams = getUrlParams;
function isMicrosoftEdgeBrowser(userAgent) {
    if (userAgent.indexOf("chrome") !== -1 && userAgent.indexOf("edg") !== -1) {
        return true;
    }
    return false;
}
function getExtensionLink() {
    let extensionId = null;
    const staging = (0, exports.isStaging)();
    let isEdgeUserAgent = isMicrosoftEdgeBrowser(window.navigator.userAgent.toLowerCase());
    console.log("#### isEdgeUserAgent", isEdgeUserAgent);
    extensionId = staging
        ? constants_1.STAGING_EXTENTION_ID_CHROME
        : constants_1.PRODUCTION_EXTENTION_ID_CHROME;
    let url = "https://chrome.google.com/webstore/detail/wordtune-ai-powered-writi/" +
        extensionId;
    if (isEdge || isEdgeChromium || isEdgeUserAgent) {
        var e = document.getElementsByClassName("add-to-chrome");
        for (var i = 0; i < e.length; i++) {
            e[i].innerText = "Add to Edge";
        }
        extensionId = staging
            ? "nidiappnajhddfmkhiegkjdokhmhpkla"
            : "fgngodlaekdlibajobmkaklibdggemdd";
        url = constants_1.EDGE_STORE_LINK + extensionId;
    }
    return url;
}
exports.getExtensionLink = getExtensionLink;
const isEditorMode = () => {
    if (react_device_detect_1.isMobile)
        return false;
    // Firefox 1.0+
    //@ts-ignore
    var isFirefox = typeof InstallTrigger !== "undefined";
    // Safari 3.0+ "[object HTMLElementConstructor]"
    var isSafari = 
    //@ts-ignore
    /constructor/i.test(window.HTMLElement) ||
        (function (p) {
            return p.toString() === "[object SafariRemoteNotification]";
        })(!window["safari"] ||
            //@ts-ignore
            (typeof safari !== "undefined" && safari.pushNotification));
    return isFirefox || isSafari;
};
exports.isEditorMode = isEditorMode;
const getEditorUrl = () => {
    return (0, exports.isStaging)()
        ? `${constants_1.WORDTUNE_BASE_URL_STG}/editor?src=website`
        : `${constants_1.WORDTUNE_BASE_URL_PROD}/editor?src=website`;
};
exports.getEditorUrl = getEditorUrl;
function getCookieExpiryFromUTM(utmSource) {
    if (utmSource)
        return constants_1.CW_TIMESTAMP[utmSource] || 60;
    return 365;
}
exports.getCookieExpiryFromUTM = getCookieExpiryFromUTM;
function expiryParamBuilder(time) {
    const expiry = new Date();
    expiry.setDate(expiry.getDate() + time + 1);
    return expiry.toUTCString();
}
exports.expiryParamBuilder = expiryParamBuilder;
function extractUTMAdIds() {
    const searchParams = new URLSearchParams(window.location.search);
    const UTMAdIdsObj = [constants_1.CAMPAIGN_SOURCE_ID, constants_1.AD_SET_ID, constants_1.AD_ID];
    const UTMAdIdsValue = UTMAdIdsObj.reduce((acc, name) => {
        acc[name] = searchParams.get(name) || null;
        return acc;
    }, {});
    return UTMAdIdsValue;
}
exports.extractUTMAdIds = extractUTMAdIds;
function isEmptyObject(obj = {}) {
    return !!Object.keys(obj).length;
}
exports.isEmptyObject = isEmptyObject;
async function fulfillWithTimeLimit(timeLimit, task, failureValue = "Time-limit") {
    let timeout;
    const timeoutPromise = new Promise((resolve, reject) => {
        timeout = setTimeout(() => {
            resolve(failureValue);
        }, timeLimit);
    });
    const response = await Promise.race([task(), timeoutPromise]);
    if (timeout) {
        clearTimeout(timeout);
    }
    if (response === failureValue) {
        console.error(response);
    }
    return response;
}
exports.fulfillWithTimeLimit = fulfillWithTimeLimit;
function detectBrandedAd(campaignName) {
    return (campaignName.toLowerCase().includes(constants_1.BRANDED_USER_STR) &&
        !campaignName.toLowerCase().includes(constants_1.NON_BRANDED_USER_STR));
}
